import React from 'react';
import classnames from 'classnames';

const Section = ({
  children,
  className,
  colour = 'transparent',
  size = 'regular',
  container = 'regular',
}) => {
  const sizeClass = (size) => {
    switch (size) {
      case 'small':
        return 'py-8 md:py-16';
      case 'regular':
      default:
        return 'py-12 md:py-24';
    }
  };

  const colourClass = (colour) => {
    switch (colour) {
      case 'dark':
        return 'bg-haiti text-white';
      case 'light':
        return 'bg-whisper';
      case 'white':
        return 'bg-white';
      case 'transparent':
      default:
        return null;
    }
  };

  const widthClass = (container) => {
    switch (container) {
      case 'narrower':
        return 'max-w-3xl';
      case 'narrow':
        return 'max-w-4xl';
      case 'regular':
      default:
        return 'max-w-6xl';
    }
  };

  const containerClass = classnames('mx-auto px-6', widthClass(container));
  const sectionClass = classnames(
    colourClass(colour),
    sizeClass(size),
    className
  );

  return (
    <section className={sectionClass}>
      <div className={containerClass}>{children}</div>
    </section>
  );
};

export default Section;
